import React, { useState, useEffect } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Page404 from '../page404';
// import { Header, Footer, LeftMenu } from "../commons/components";
// import { Content } from "./components";
import Mainhome from './home';

import { Redirect } from 'react-router';
import { isAuth } from '../auth/actions';
import EditProfile from './edit';
import ChangePassword from './change-password';

export default function Home() {
  const { path } = useRouteMatch();

  useEffect(() => {
    document.title = `Profile - Ubaform Admin`;
  }, []);
  // console.log( path , '13_path...')

  return (
    <React.Fragment>
      {isAuth() ? (
        <Switch>
          <Route exact path={path}>
            <Mainhome />
          </Route>
          <Route exact path={`${path}/edit/:id`}>
            <EditProfile />
          </Route>
          <Route exact path={`${path}/change-password/:id`}>
            <ChangePassword />
          </Route>
        </Switch>
      ) : (
        <Redirect to='/auth' />
      )}
    </React.Fragment>
  );
}
